import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchAccountConfirmInput.scss";

interface AchAccountConfirmInputProps {
    achAccount: string;
    achAccountConfirm: string;
    onSetAchAccountConfirm: (amount: string) => void;
    onSetIsAchAccountConfirmValid: (isAmountValid: boolean) => void;
}

export const AchAccountConfirmInput: React.FunctionComponent<AchAccountConfirmInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchAccountError = 'ACH Confirm Account is a required field.';
    const notTheSameAchAccountError = 'ACH Confirm Account should be the same as ACH Account.';

    useEffect(() => {
        props.onSetIsAchAccountConfirmValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchAccountConfirm(value);
        validateAchAccount();
    }

    useEffect(() => {
        if (props.achAccountConfirm) {
            validateAchAccount();
        }
    }, [props.achAccount, props.achAccountConfirm]);

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchAccount();
    }

    const validateAchAccount = () => {
        let errorsTemp: string[] = [];
        if (props.achAccountConfirm === '') {
            errorsTemp.push(requiredAchAccountError);
        }
        if (props.achAccountConfirm !== props.achAccount) {
            errorsTemp.push(notTheSameAchAccountError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-account-confirm-container">
        <Input isValid={isValid} type='text' required={true} value={props.achAccountConfirm} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
